import { Alert, Box, Flex, Text } from '@mantine/core';
import Info from '@material-design-icons/svg/outlined/info.svg';

export const Warning = ({ error }: { error: string }) => {
  return (
    <Alert variant="dimmed">
      <Flex
        align="center"
        gap="md"
      >
        <Box style={{ minWidth: 24 }}>
          <Info />
        </Box>
        <Text
          size="md"
          fw={500}
        >
          {error}
        </Text>
      </Flex>
    </Alert>
  );
};
